module.exports = __webpack_public_path__ + "static/img/news35_12.24b6092.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/report/news35/news35_12.png
// module id = KV2f
// module chunks = 0